import { Component, OnInit, Input } from '@angular/core';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { Stand } from 'src/app/entity/Stand';
 
 

@Component({
  selector: 'app-stands-exposant',
  templateUrl: './stands-exposant.component.html',
  styleUrls: ['./stands-exposant.component.scss']
})
export class StandsExposantComponent implements OnInit {

@Input()
stands:Stand[];
@Input()
clientId:number;


  constructor(private exhibitorService:ExhibitorService) { }

  ngOnInit() {
  }
  async remove(stand: Stand) {
 
    await  this.exhibitorService.updateStands(this.clientId,stand.idStand,false);
 
    this.exhibitorService.subscribeStandClient(this.clientId);
     }
}
